import api from '@/services/base.service'

const methods = {
  getSucursales() {
    return api.get(`/sucursales`)
  },
  getSucursal(id) {
    return api.get(`/sucursales/${id}`)
  },
  addSucursal(sucursal) {
    return api.post(`/sucursales`, sucursal)
  },
  updateSucursal(id, sucursal) {
    return api.put(`/sucursales/${id}`, sucursal)
  },
  deleteSucursal(id) {
    return api.delete(`/sucursales/${id}`)
  }
}

export default methods
